import {API_ROUTES} from '../constants';
import api from 'services/axios';
import apiWithRetry from 'services/axiosInstanceRetry';
import { ISignIn, ISignUp, IGoogleSignIn, IGoogleSignUp, IFirebaseSignIn, IFirebaseSignUp } from 'types/auth';
import {WithToken} from 'types/api';

export async function signIn(data: ISignIn | IGoogleSignIn | IFirebaseSignIn): Promise<WithToken> {
  const response = await api.post(API_ROUTES.AUTH.LOGIN, data);
  return response?.data;
}

export async function shortTimeout(): Promise<any> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({success: true});
    }, 500);
  });
}

export async function signup(data: ISignUp | IGoogleSignUp | IFirebaseSignUp): Promise<WithToken> {
  const response = await api.post(API_ROUTES.AUTH.USER, data);
  return response?.data;
}

export async function verifyEmail(): Promise<WithToken> {
  const response = await api.post(API_ROUTES.AUTH.VERIFY_EMAIL);
  return response?.data;
}

export async function sendVerifyEmailLink(): Promise<WithToken> {
  const response = await api.post(API_ROUTES.AUTH.SEND_VERIFY_EMAIL_LINK);
  return response?.data;
}

export async function updatePushToken(pushToken: string): Promise<any> {
  // Retry 3 times with exponential backoff (5s, 10s, 20s), total 4 tries, to make sure the token is updated
  const response = await apiWithRetry.post(API_ROUTES.AUTH.PUSH_TOKEN, { push_token: pushToken });
  return response?.data;
}
